export default __webpack_public_path__ + "static/media/Figma.da72b4ea.svg";